<template>
  <div class="pricing-page" id="pricing">
    <section class="pricing-intro">
      <h1>
        {{ $t('home-page.plans.get-more-title') }}
        <span>{{ $t('plans.premium-title') }}</span>
      </h1>

      <div class="s-plans-container-toggle">
        <span @click="togglePrice = false" class="s-margin-l-auto  monthly s-no-select s-transition-03 " :class="[{'active' : !togglePrice}, {'s-pointer' : togglePrice}]">{{ $t('plans.monthly-title') }}</span>
        <s-toggle  v-model="togglePrice" class="s-toggle-small s-toggle-ant-invert s-toggle-blue"/>
        <span @click="togglePrice = true" class="s-margin-r-auto  annually s-no-select s-transition-03" :class="[{'active' : togglePrice}, {'s-pointer' : !togglePrice}]">{{ $t('plans.annually-title') }}<br><small>( {{ $t('plans.free-subtitle') }} )</small></span>
      </div>

    </section>

    <section class="pricing-plans-parent">
      <div class="pricing-plans-bg bg-shade bg-center">
        <PricingPlansContainer :togglePrice="togglePrice"/>
      </div>
    </section>
    <div></div>

    <!-- promotion-lite old it -->
    <section class="pricing-promotion-lite-hero" id="promotion-lite">
<!--      <img src="~@/assets/images/Lite_Logo_SVG.svg" alt/>-->
        <h1>{{ $t('seedr-title') }}</h1>
        <s-button class="s-button-upgrade lite s-no-pointer" iconImage="SVG/plan_lite_logo_SVG.svg">{{ $t('plans.lite-title') }}</s-button>
    </section>

    <article class="pricing-promotion-lite-container">
      <section class="pricing-promotion-lite-a">
        <div class="pricing-promotion-lite-a-title">
          <h1>{{ $t('lite-promotion.available-title') }}</h1>
          <hr class="hr-grey"/>
          <h2>{{ $t('lite-promotion.find-anywhere-title') }}</h2>
          <h2>{{ $t('lite-promotion.ideal-title') }}</h2>
        </div>
        <div class="pricing-promotion-lite-a-points">
          <ul>
            <li>{{ $t('lite-promotion.management-title') }}</li>
            <li>{{ $t('lite-promotion.transfers-title') }}</li>
            <li>{{ $t('lite-promotion.sync-title') }}</li>
            <li>{{ $t('lite-promotion.find-title') }}</li>
          </ul>
          <hr class="hr-grey"/>
          <ul class="li-blue-s">
            <li>{{ $t('lite-promotion.download-title') }}</li>
            <li>{{ $t('lite-promotion.storage-title') }}</li>
            <li>{{ $t('lite-promotion.tasks-title') }}</li>
          </ul>
        </div>
      </section>

      <section class="pricing-promotion-lite-b">
        <CardPlanBase
          class="card-plan-lite"
          :planName="$t('plans.lite-title')"
          price="3"
          btn="button-primary-blue"
          :msg="$t('actions.go-lite')"
          btnLink="/payment"
        />

        <h3>{{ $t('lite-promotion.recommended-title') }}
          <br>{{ $t('lite-promotion.personal-title') }}
          <br>{{ $t('lite-promotion.pro-title') }}
        </h3>
      </section>
    </article>

    <section class="pricing-faq-section">
      <div class="pricing-faq-bg bg-shade">

        <h1>{{ $t('pricing-page.questions-title') }}</h1>

        <PricingFAQ
          :faqTitle="$t('pricing-page.faq.a-title')"
          :articleText="$t('pricing-page.faq.a-text')"
          faqLink="/pricing#pricing"
          :linkText="$t('actions.see-plan-details')"
        />
        <PricingFAQ
          :faqTitle="$t('pricing-page.faq.b-title')"
          :articleText="$t('pricing-page.faq.b-text')"
          faqLink="/pricing#pricing"
          :linkText="$t('actions.upgrade-now')"
        />
        <PricingFAQ
          :faqTitle="$t('pricing-page.faq.c-title')"
          :articleText="$t('pricing-page.faq.c-text')"
          faqLink="/pricing#pricing"
          :linkText="$t('actions.see-plans')"
        />

        <PricingFAQ
          :faqTitle="$t('pricing-page.faq.d-title')"
          :articleText="$t('pricing-page.faq.d-text')"
          faqLink=""
          :linkText="$t('actions.change-payment')"
        />
        <PricingFAQ
          :faqTitle="$t('pricing-page.faq.e-title')"
          :articleText="$t('pricing-page.faq.e-text')"
          faqLink="/pricing#pricing"
          :linkText="$t('actions.see-premium-plans')"
        />
        <PricingFAQ
          :faqTitle="$t('pricing-page.faq.f-title')"
          :articleText="$t('pricing-page.faq.f-text')"
          faqLink=""
          :linkText="$t('actions.my-subscription')"
        />

        <div class="pricing-faq-link">
          <a class="link-b" href="https://www.seedr.cc/faq/"></a>
          <a class="link-b" href="https://help.seedr.cc/hc/en-us/requests/new">{{$t('actions.contact-us')}}</a>
        </div>
      </div>
    </section>

    <section class="pricing-support-parent">
      <div class="pricing-support-bg bg-shade">
        <div class="pricing-support-cards card-wide card-shade">
          <h1>{{ $t('pricing-page.support-title') }}</h1>
          <ul class="pricing-support-col">
            <li>
              <h3>{{ $t('pricing-page.support-a-title') }}</h3>
              <p>{{ $t('pricing-page.support-a-text') }}</p>
            </li>
            <li>
              <h3>{{ $t('pricing-page.support-b-title') }}</h3>
              <p>{{ $t('pricing-page.support-b-text') }}</p>
            </li>
            <li>
              <h3>{{ $t('pricing-page.support-c-title') }}</h3>
              <p>{{ $t('pricing-page.support-c-text') }}</p>
            </li>
          </ul>
        </div>

        <div class="pricing-link pricing-link-products">
          <a href="/#home-products">{{$t('actions.see-products')}}</a>
        </div>
      </div>
    </section>

    <section class="pricing-payment">
      <div class="pricing-payment-bg bg-shade">
        <h1>{{ $t('pricing-page.paying-title') }}</h1>
        <div class="pricing-payment-cards">
          <!-- TODO: Change paying-text translation names and content once its done -->
          <CardBase
            imageSource="Web_Paypal_Color_SVG.svg"
            cardTitle="PayPal"
            :cardText="$t('pricing-page.paying-text')"
            cardLink="https://www.paypal.com/"
          />

          <CardBase
            imageSource="Web_Fastspring_Color_SVG.svg"
            cardTitle="Fastspring"
            :cardText="$t('pricing-page.paying-text')"
            cardLink="https://fastspring.com"
          />

          <CardBase
            imageSource="Web_Bitcoin_Color_SVG.svg"
            :cardText="$t('pricing-page.paying-text')"
            cardTitle="Bitcoin"
            cardLink="https://bitcoin.org"
          />
        </div>
        <div class="pricing-link">
          <a href="#pricing">{{$t('actions.see-premium-plans')}}</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PricingPlansContainer from '@/components/PricingPlansContainer.vue'
import CardPlanBase from '@/components/CardPlanBase.vue'
import CardBase from '@/components/CardBase.vue'
import PricingFAQ from '@/components/PricingFAQ.vue'
// import SIcon from '@/components/SIcon.vue'
import SButton from '@/components/SButton.vue'
import SToggle from "@/components/SToggle.vue";

export default {
  name: 'pricing',
  components: {
    SToggle,
    CardPlanBase,
    CardBase,
    PricingFAQ,
    PricingPlansContainer,
    SButton
  },
  props: {
  },
  data () {
    return {
      togglePrice: false
    }
  }
}
</script>

<style scoped lang="scss">

</style>
